import Wrapper from '@/components/wrapper/Wrapper'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"
import ServiceUpdateComp from '@/client/components/service-update-comp/ServiceUpdateComp'
import { useLocation, useNavigate } from 'react-router-dom';
import DataNotFound from '@/components/data-not-found/DataNotFound';

const Updates = () => {
    const { state: serviceUpdates } = useLocation();
    const navigate = useNavigate();

    if (!serviceUpdates) {
        navigate(-1);
    }

    return (
      <Wrapper>
        <div>
          <div className="section-heading-container">
            <h1 className="section-heading">Updates</h1>
          </div>

          <Table className="mt-4 glass-header !border-white !border-2 ">
            <TableHeader>
              <TableRow className="text-lg max-[560px]:text-xs">
                {/* <TableHead>Client Name</TableHead> */}
                {/* <TableHead>Status</TableHead> */}
                <TableHead>Date</TableHead>
                <TableHead>Document</TableHead>
                <TableHead>Description</TableHead>
                {/* <TableHead>Actions</TableHead> */}
              </TableRow>
            </TableHeader>
            <TableBody>
              {serviceUpdates?.length === 0 && (
                <DataNotFound name={"Service Updates"} />
              )}

              {serviceUpdates?.map((update) => (
                <ServiceUpdateComp key={update?._id} update={update} />
              ))}
            </TableBody>
          </Table>
        </div>
      </Wrapper>
    );
}

export default Updates